module.exports = __webpack_public_path__ + "static/assets/f9868658d8483a6dbcd600e0226dfeef.mp3";